import { DayCalendar } from "@/features/forecast/DayCalendar";
import { AreaCards, DaysBlock, ReadingFootnote, SignsLine } from "@/features/forecast/ForecastCards";
import type { WeekReading } from "@/lib/api/models/week";
import { Button } from "@/ui/Button";
import { Screen } from "@/ui/Screen";
import { Display, Label } from "@/ui/Text";

interface WeekRevealProps {
  readonly week: WeekReading;
  readonly onContinue: () => void;
}

/**
 * The first thing a person gets for their birth details: their own week.
 *
 * Four areas they actually worry about, each with one line, a do and a don't.
 * The tone of each area comes from the engine and the classical transit
 * rules; the words may come from the model. Today shows the same cards for
 * the day, the week and the month once they have an account.
 */
export function WeekReveal({ week, onContinue }: WeekRevealProps) {
  return (
    <Screen foot={<Button label="Speak to Antar" onClick={onContinue} />}>
      <Label>Your week · {week.week.label}</Label>
      <SignsLine moonRashi={week.signs.moon_rashi} lagnaRashi={week.signs.lagna_rashi} />
      <Display className="mt-3">{week.headline}</Display>
      {week.days.length > 0 ? (
        <div className="mt-5 border-y-[1.5px] border-ink py-4">
          <DayCalendar days={week.days} />
        </div>
      ) : (
        <DaysBlock best={week.best_days} careful={week.careful_days} />
      )}
      <AreaCards areas={week.areas} period="week" />
      <ReadingFootnote period="week" />
    </Screen>
  );
}
